import { render } from "./AdditionalRecipientsStandalone.vue?vue&type=template&id=b44cc964&scoped=true"
import script from "./AdditionalRecipientsStandalone.vue?vue&type=script&lang=js"
export * from "./AdditionalRecipientsStandalone.vue?vue&type=script&lang=js"

import "./AdditionalRecipientsStandalone.vue?vue&type=style&index=0&id=b44cc964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b44cc964"]])

export default __exports__